<template>
    <div
        :style="{ maxWidth: maxWidth, width: '100%' }"
        v-html="formatted"
        class="cell-wrapper flex"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ColumnConfig, WidgetTemplateColumnWithConfig } from '@/types/dashboard'
import { DATE_COLUMNS, DATE_FORMAT, DATE_TIME_COLUMNS, DATE_TIME_FORMAT } from '@/helpers/table'
import { dayjs } from '@/composables/useDayjs'
import { DEFAULT_COLUMN_WIDTH } from '@/enum/redesignTableConfig'

type ValueType = unknown

const props = defineProps<{
    value: ValueType
    column: WidgetTemplateColumnWithConfig
    columnConfig: ColumnConfig
}>()

const maxWidth = computed(() => {
    const width = props.columnConfig?.width ?? DEFAULT_COLUMN_WIDTH
    return `${width - 10}px`
})
const formatDateColumn = (rowValue: ValueType, dateFormat: string): string => {
    if (!rowValue) return '--'
    if (typeof rowValue !== 'string') return String(rowValue)

    const parsedDate = dayjs(rowValue)
    if (parsedDate.isValid()) {
        return parsedDate.format(dateFormat)
    }

    return rowValue.replace(/\//g, '-')
}

const formatted = computed(() => {
    const columnValue = props.value

    if (DATE_TIME_COLUMNS.includes(props.column.prop.toLowerCase())) {
        return columnValue ? formatDateColumn(columnValue, DATE_TIME_FORMAT) : '--'
    }

    if (DATE_COLUMNS.includes(props.column.prop.toLowerCase())) {
        return columnValue ? formatDateColumn(columnValue, DATE_FORMAT) : '--'
    }

    if (columnValue === null || columnValue === undefined || columnValue === '') {
        return '--'
    }

    return columnValue
})
</script>
